import { Reveal } from "../site/Reveal";

const DOCS = [
  { tag: "Documento ufficiale", title: "Attestazione SOA", border: "border-blue-500", tagColor: "text-blue-300",
    lines: ["N. 11023/63/01 — SOA Consult", "Categoria OG 1, classifica II", "Qualificazione per l'esecuzione di lavori pubblici"] },
  { tag: "Regolarità contributiva", title: "DURC Operativo", border: "border-emerald-500", tagColor: "text-emerald-300",
    lines: ["Esito INPS: regolare", "Regolarità INPS, INAIL e Casse Edili"] },
  { tag: "Identità giuridica", title: "Registro Imprese", border: "border-slate-400", tagColor: "text-slate-300",
    lines: ["P.IVA / C.F. 03216710735", "REA MI-2625081", "Capitale sociale € 257.000 i.v.", "Costituita il 27/05/2019"] },
  { tag: "Presenza sul territorio", title: "Sedi Operative", border: "border-amber-500", tagColor: "text-amber-300",
    lines: ["Sede legale: Piazza Quattro Novembre 4, 20124 Milano (MI)", "Sede operativa: Vicolo San Martino 10, 20016 Pero (MI)"] },
];

export const TechTrust = () => (
  <section id="dati" data-testid="trust-section" className="py-20 bg-slate-900 text-white">
    <div className="max-w-7xl mx-auto px-6">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-5">
          <Reveal>
            <span className="text-xs font-mono uppercase tracking-widest text-blue-400">Trasparenza Amministrativa</span>
            <h2 className="text-3xl font-extrabold uppercase mt-1 mb-4">I Pilastri di Garanzia Saircos</h2>
            <p className="text-sm text-slate-300 leading-relaxed mb-6">
              La certezza di affidare l'opera a una società strutturata: regolarità contributiva verificata,
              attestazione SOA per lavori pubblici e visura camerale aggiornata.
            </p>
            <div className="p-4 bg-slate-950 border border-slate-800 text-xs font-mono text-slate-300 space-y-2">
              <div className="flex justify-between gap-4"><span className="text-slate-400">Ragione Sociale:</span><span className="text-white font-bold text-right">SAIRCOS S.R.L.</span></div>
              <div className="flex justify-between gap-4"><span className="text-slate-400">Settore di Attività:</span><span className="text-white font-bold text-right">Costruzioni &amp; Ristrutturazioni</span></div>
              <div className="flex justify-between gap-4"><span className="text-slate-400">Committenti:</span><span className="text-white font-bold text-right">Condomini · Privati · PA</span></div>
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {DOCS.map((d, i) => (
            <Reveal key={d.title} delay={i * 0.08}>
              <div data-testid={`trust-card-${i}`} className={`h-full bg-slate-800 p-6 border-l-4 ${d.border}`}>
                <span className={`text-[11px] font-mono uppercase ${d.tagColor}`}>{d.tag}</span>
                <h3 className="text-lg font-bold text-white mt-1 mb-3">{d.title}</h3>
                <ul className="space-y-1.5">
                  {d.lines.map((l) => (
                    <li key={l} className="text-xs text-slate-300 leading-relaxed font-mono">{l}</li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
